module.exports = __webpack_public_path__ + "img/DSCF0981.8a470c97.jpeg";